import { DisplayGroup } from '@common/components/forms/fields';
import { PageCard, PageCardProps } from '@common/components/layout';
import { HospitalModel } from '@common/models';
import { normalizePhone } from '@common/utils/phoneUtils';
import { observer } from 'mobx-react';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

type IProps = {
    hospital: HospitalModel
} & PageCardProps

export const LocationDetailStaticInfo = observer(({ hospital, ...cardProps }: IProps) => (
    <PageCard title="Location Details" {...cardProps}>
        <Row className="pt-2">
            <Col md={6}>
                <DisplayGroup controlid="hospitalName" text="Name" value={hospital.name} />
            </Col>
            <Col md={3} >
                <DisplayGroup controlid="locationName" text="Location Code" value={hospital.store?.code} />
            </Col>
            <Col md={3} >
                <DisplayGroup controlid="department" text="Department" value={hospital.store?.market.name} />
            </Col>
        </Row>
        <Row className="pt-4">
            <Col md={6}>
                <DisplayGroup controlid="streetAddress1" text="Address #1" value={hospital.store?.address} />
            </Col>
            <Col md={6}>
                <DisplayGroup controlid="streetAddress2" text="Address #2" value={hospital.store?.address2} />
            </Col>
        </Row>
        <Row className="pt-4">
            <Col md={3}>
                <DisplayGroup controlid="city" text="City" value={hospital.store?.city} />
            </Col>
            <Col md={3}>
                <DisplayGroup controlid="state" text="State" value={hospital.store?.state.name} />
            </Col>
            <Col md={3}>
                <DisplayGroup controlid="zipCode" text="Zip Code" value={hospital.store?.zipCode} />
            </Col>
        </Row>
        <Row className="pt-4">
            <Col md={3}>
                <DisplayGroup controlid="storePhone" text="Phone" value={normalizePhone(hospital.store?.phone)} />
            </Col>
            <Col md={3}>
                <DisplayGroup controlid="storePhone2" text="Secondary Phone" value={normalizePhone(hospital.store?.secondaryPhone)} />
            </Col>
        </Row>
    </PageCard>
))
